module.exports = __webpack_public_path__ + "static/media/page-header.276a7b6b.jpg";